function isEmpty(obj) {
    // Check if the object has no properties
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}
export default isEmpty;